import { Dialog, ThemeProvider } from '@mui/material'
import './PtaMeetingPopup.scss';
import { FETCH_POLICY, messages, theme } from '../../utils/constants';
import { FC, useEffect, useState } from 'react';
import images from '../../assets/images';
import CopyToClipboard from 'react-copy-to-clipboard';
import ToasterWithMessage from '../toaster';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useMutation } from '@apollo/client';
import { EDIT_CATEGORY } from '../../pages/AdminPta/api/PtaQuery';
import { MeetingCategoryType } from '../../pages/AdminPta/AdminPta';
import { getScreenDimensions } from '../../utils/helper';

interface PropsType{
  openPopup: boolean;
  closePopup: () => void;
  message: string;
  type: 'generateCode' | 'copyCode' | 'editCategory' | 'shareCode';
  handleClick?: () => void;
  value: string | undefined;
  setRefetch: (value: boolean) => void;
  refetch: boolean;
  clickedCategoryDetails: MeetingCategoryType | undefined;
}

interface IFormInput {
  categoryName: string;
  description: string;
}

const schema = yup.object().shape({
  categoryName: yup.string()
  .required(messages.meetingType).trim()
  // .matches(patterns?.alphaNumericSpace, messages?.meetingTypeCharacter)
  // .matches(patterns?.NotStartWithNumber,messages?.meetingTypeNotStartWithNumber)
  .max(100, messages?.meetingTypeLength),
  description: yup.string().required(messages.desription).max(250, messages.descriptionLength),
});
 
const PtaMeetingPopup: FC<PropsType> = ({ openPopup, closePopup, message, type, handleClick, value, setRefetch, refetch, clickedCategoryDetails }) => {

  const { closeIcon, CopyCode, CopyCodeWhite } = images;
  const { success, error } = ToasterWithMessage();
  const methods = useForm<IFormInput>({ resolver: yupResolver(schema) });
  const { handleSubmit, register, formState: {errors}, reset } = methods;
  const { isMobileScreen } = getScreenDimensions();
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const copyBtn = () => (
    <CopyToClipboard text={value ? value : ""} onCopy={(isMobileScreen && !isCopied) ? () => setIsCopied(true) : handleCopyCode}>
      {isMobileScreen ? (
        <button className={`${type === "shareCode" ? "okButtonStyle" : 'copyButton'} mobileCopyButton ${isCopied ? "copiedButton" : ""}`}>
          <img src={isCopied ? CopyCodeWhite : CopyCode} className='mobileCopyIcon' />
        </button>
      ) : (
        <button className={type === "shareCode" ? "okButtonStyle" : 'copyButton'}>
          Copy
        </button>
      )}
    </CopyToClipboard>
  );

  const handleCopyCode = () => {
    if (!isMobileScreen) {
      success('Copied to clipboard');
    }
    setIsCopied(false);
    closePopup();
  };

  const [updateCategory, { loading }] = useMutation(EDIT_CATEGORY, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: () => {
      success("Updated succesfully");
      setRefetch(!refetch);
      closePopup();
      reset();
    },
    onError: (err) => {
      error(err?.message);
    }
  })

  const onSubmit: SubmitHandler<IFormInput> = data => {

    if ((clickedCategoryDetails?.mcOriginalType)?.toLowerCase() === (data?.categoryName).toLowerCase() && clickedCategoryDetails?.mcDescription === data?.description) {
      closePopup();
      reset();
      return;
    }

    if (clickedCategoryDetails) {
      updateCategory({
        variables: {
          input: {
            mcId: clickedCategoryDetails?.mcId,
            mcType: data?.categoryName,
            mcDescription: data?.description
          }
        }
      })
    }
  };

  useEffect(() => {
    if (clickedCategoryDetails) {
      reset({
        description: clickedCategoryDetails?.mcDescription,
        categoryName: clickedCategoryDetails?.mcOriginalType
      })
    }
  }, [clickedCategoryDetails])  

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={openPopup} classes={{ paper: 'warnPaperStylePta' }}>
        <div className={`closeIconContainer ${(isMobileScreen && type !== "editCategory") ? "hideCloseIcon" : ""}`}>
          <img src={closeIcon} className='closeIcon' onClick={closePopup} alt='closeIcon'/>
        </div>

        {(type !== "editCategory") && (
          <div className={`ptaPopupContainer ${type === "shareCode" && "shareCodeContainer"}`}>
            <div className='messageContainer'>
              { message }
            </div>
            <div className={`copyBoxContainer ${type === "shareCode" && "copyBoxContainerShare"}`}>
              {(type === "shareCode") && <img src={CopyCode} className='copyIcon' alt='copyIcon'/>}
              <div className='copyBox'>
                { (isMobileScreen && isCopied) ? "Copied!" : value }
              </div>
              {(type === 'copyCode') && copyBtn() }
            </div>
            {(type === "shareCode") ? copyBtn() : (
              <button className={`okButtonStyle ${ type === 'copyCode' && "btnHide"}`} onClick={type === 'generateCode' ? handleClick : closePopup}>
                Generate
              </button>
            )}
          </div>
        )}

        {(type === "editCategory") && (
          <div className="editCategoryContainer">
            <form autoComplete="off" className="editCategoryForm" onSubmit={handleSubmit(onSubmit)} noValidate>
              <div className='inputContainer'>
                <span className='label'>Meeting type</span>
                <input
                  id="categoryName"
                  {...register("categoryName")}
                  type="text"
                  className="categoryNameField field"
                />
                {errors?.categoryName && <span className='error'>{ errors?.categoryName?.message }</span> }
              </div>
              <div className='inputContainer'>
                <span className='label'>Description</span>
                <textarea
                  id="description"
                  {...register("description")}
                  className="descriptionField no-resize field"
                />
                {errors?.description && <span className='error'>{ errors?.description?.message }</span> }
              </div>
              <button type='submit' disabled={loading} className='submitButtonStyle'>Done</button>
            </form>
          </div>
        )}
      </Dialog>
    </ThemeProvider>
  )
}

export default PtaMeetingPopup;
